import type { CustomCodeParseResult } from 'components/DashboardGrid/hooks/customCodeBlock';

export const shouldShowCodeError = (
  parsed: CustomCodeParseResult,
  touched: boolean
): boolean => !parsed.ok && (parsed.error !== 'empty' || touched);
